import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=5a61f81c&"
import script from "./ActivityView.vue?vue&type=script&lang=js&"
export * from "./ActivityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports